module.exports = __webpack_public_path__ + "img/lottie-step-3.7a870792.png";